import React from 'react';
import { Form, Button } from 'react-bootstrap';

const FormGroupCreator = ({
  newGroupName,
  setNewGroupName,
  onCreateGroup
}) => {
  return (
    <Form>
      <Form.Group>
        <Form.Label>Create New Form Group</Form.Label>
        <Form.Control
          value={newGroupName}
          onChange={(e) => setNewGroupName(e.target.value)}
          placeholder="Group name"
        />
      </Form.Group>
      <Button className="mt-2" onClick={onCreateGroup}>
        + Add Form Group
      </Button>
    </Form>
  );
};

export default FormGroupCreator;
